import api from '@/api.js'
import {
	Message
} from 'element-ui'

//全部控制
export async function lockStatus(courseClassId, teacherId, type,device) {
	
	try {
		const res = await api.post(api.school.updateControlStudentPage, {
			courseClassId: Number(courseClassId),
			controlStudentPage: type,
			teacherId: Number(teacherId),
		})
		Message.success(type === 1 ? '已锁屏，学生端将无法操作！' : '已解锁，学生端可以继续操作！')
		
		
		return true
	} catch (err) {
		Message.error('操作失败，请重试！')
		console.error(err)
		return false
	}
}
export async function postClassGlobalConfig(from) {
	
	try {
		const res = await api.post(api.school.postClassGlobalConfig,from)
		
		return true
	} catch (err) {
		Message.error('操作失败，请重试！')
		console.error(err)
		return false
	}
}
export async function getClassGlobalConfig(from) {
	try {
		const res = await api.get(api.school.getClassGlobalConfig,from)
		return res
	} catch (err) {
		Message.error('操作失败，请重试！')
		console.error(err)
		return false
	}
}

//单个全部控制
export async function lockStudentStatus(item, courseClassId, teacherId, newStatus) {
	
	try {
		const res = await api.post(api.school.updateControlStudentPage, {
			courseClassId: Number(courseClassId),
			studentId: Number(item.studentId),
			controlStudentPage: newStatus,
			teacherId: Number(teacherId),
		})
		Message.success(newStatus === 1 ? `${item.studentName}已锁定学生端将无法操作！` : `${item.studentName}已解锁，学生端可以继续操作！`)
		return true
	} catch (err) {
		Message.error('操作失败，请重试！')
		console.error(err)
		return false
	}
}